/**
 * @deprecated Use the `MathUtils` module from `@colonist/utils` instead
 */ (function(MathUtils) {
    function isNumberBetween(myNumber, minValue, maxValue) {
        if (myNumber < minValue) return false;
        if (myNumber > maxValue) return false;
        return true;
    }
    MathUtils.isNumberBetween = isNumberBetween;
    function lerp(inputStart, inputEnd, outputStart, outputEnd, value) {
        return (value - inputStart) / (inputEnd - inputStart) * (outputEnd - outputStart) + outputStart;
    }
    // Remap a value so it linearly interpolates between `outputStart` and `outputEnd`
    // If `value` === `inputStart` this function returns `outputStart`. If `value` === `inputEnd` it returns `outputEnd`
    // If the value is in between linearly interpolate between the values
    // It's perfectly valid to have start greater than end, in that case the output will decrease depending on `value`
    /**
     * @deprecated Use the `lerp` function from `@colonist/utils` instead
     */ MathUtils.lerp = lerp;
    function calculatePercentage(midNumber, lowerBound, upperBound) {
        return 100 * (midNumber - lowerBound) / (upperBound - lowerBound);
    }
    MathUtils.calculatePercentage = calculatePercentage;
    function clampBetweenZeroAndOne(input) {
        return clamp(input, 0, 1);
    }
    MathUtils.clampBetweenZeroAndOne = clampBetweenZeroAndOne;
    function clamp(input, min, max) {
        return Math.max(Math.min(input, max), min);
    }
    /**
     * @deprecated Use the `clamp` function from `@colonist/utils` instead
     */ MathUtils.clamp = clamp;
})(MathUtils || (MathUtils = {}));
export var MathUtils;
